import React from 'react'
import { observer } from 'mobx-react-lite'
import { capitalize } from 'lodash'
import { Alert, Icon, Label, Switch, Tooltip, Typography } from 'shared/ui'
import { type EnrollByWebhookStore } from 'widgets/EnrollByWebhook/store/EnrollByWebhookStore.ts'
import { ENROLL_BY_WEBHOOK_TOOLTIP } from 'widgets/EnrollByWebhook/text.ts'
import { EnrollByWebhookCopyInput } from 'widgets/EnrollByWebhook/EnrollByWebhookCopyInput.tsx'
import styles from './styles.module.scss'

export const EnrollByWebhook = observer(
  ({
    store,
    source,
    specificSource,
    isHideTrigger,
  }: {
    store: EnrollByWebhookStore
    source: 'campaign' | 'workflow' | 'agent'
    specificSource?: string
    isHideTrigger?: boolean
  }) => {
    const { isActive, setActive, webhookUrl } = store

    return (
      <div className={styles.wrap}>
        {!isHideTrigger && (
          <div className={styles.wrapEnroll}>
            <div className={styles.left}>
              <Typography
                ariaLabel={'title'}
                variant={'text-input-field-r'}
                color={'var(--content-primary-secondary)'}
              >
                Enroll contacts by webhook
              </Typography>
              <Tooltip placement={'top'} breakWord label={ENROLL_BY_WEBHOOK_TOOLTIP}>
                <Icon
                  icon={'questionFull'}
                  color={'var(--content-neutral-primary)'}
                  fontSize={12}
                  padding={2}
                />
              </Tooltip>
            </div>
            <Switch value={isActive} onChange={setActive} />
          </div>
        )}
        {isActive &&
          (webhookUrl ? (
            <div className={styles.webhookWrap}>
              <Label
                label={{
                  text: 'Webhook URL',
                }}
              />
              <EnrollByWebhookCopyInput webhookUrl={webhookUrl} />
              <div className={styles.helper}>
                <Typography
                  ariaLabel={'text'}
                  variant={'text-input-helper'}
                  color={'var(--content-primary-secondary)'}
                >
                  {`This URL works only while the ${source} is active.`}
                </Typography>
              </div>
            </div>
          ) : (
            <div className={styles.emptyWebhookWrap}>
              <div className={styles.info}>
                <Typography
                  ariaLabel={'label'}
                  variant={'text-input-label-small'}
                  color={'tertiary'}
                >
                  Webhook URL
                </Typography>
                <Typography ariaLabel={'howItWorks'} variant={'body-md-regular'}>
                  How it works:
                  <ul className={styles.list}>
                    <li>{"Creates a contact if one doesn't exist"}</li>
                    <li>Enrolls the contact in your {specificSource || capitalize(source)}</li>
                  </ul>
                </Typography>
              </div>
              <Alert
                item={{
                  type: 'infoLight',
                  title: 'Webhook URL not available yet',
                  desc: `Activate this ${source} to copy your webhook URL in a confirmation window.`,
                }}
              />
            </div>
          ))}
      </div>
    )
  }
)
